module.exports = ({
    "CDMS700P001": "กรุณากรอกรหัสผู้ใช้งาน",
    "CDMS700P002": "กรุณากรอกรหัสผ่าน",
    "CDMS700MSG001": "กรุณาระบุรหัสผู้ใช้งาน (User ID)",
    "CDMS700MSG002": "กรุณาระบุรหัสผ่าน",
    "CDMS700MSG003": "รหัสผู้ใช้งานหรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
    "CDMS700MSG004": "ไม่สามารถอัปเดตข้อมูลได้เนื่องจากข้อมูลบางส่วนได้รับการเปลี่ยนแปลง กรุณารีเฟรชหน้า",
    "CDMS700MSG005": "ไม่สามารถตั้งค่าสถานะของ {level} เนื่องจากรายการถูกล็อก",
    "CDMS706H001": "สถานวิจัย",
    "CDMS706H002": "รหัสผู้เข้าร่วมวิจัย",
    "CDMS706H003": "นัดหมาย",
    "CDMS706H004": "Page",
    "CDMS706H005": "Block",
    "CDMS706H006": "Line No.",
    "CDMS706H007": "คำถาม",
    "CDMS706H008": "สถานะการกรอกข้อมูล",
    "CDMS706H009": "Open query",
    "CDMS706H010": "จำนวน Query ที่ตอบแล้ว",
    "CDMS706H011": "e-Signature",
    "CDMS706H012": "Freeze",
    "CDMS706H013": "SDV",
    "CDMS706H014": "Review",
    "CDMS706H015": "Lock",
    "CDMS700TT001": "สถานะ (สถานวิจัย)",
    "CDMS701TT001": "สถานะ (ผู้เข้าร่วมวิจัย)",
    "CDMS702TT001": "สถานะ (การนัดหมาย)",
    "CDMS703TT001": "Page Status",
    "CDMS704TT001": "Block Status",
    "CDMS705TT001": "Line Status",
    "CDMS706TT001": "Question Status",
    "CDMS706OPT001": "ไม่สมบูรณ์",
    "CDMS706OPT002": "เสร็จสมบูรณ์บางส่วน",
    "CDMS706OPT003": "เสร็จสมบูรณ์",
    "CDMS706OPT004": "N/A",
    "CDMS706LB001": "* สำหรับการป้อนรหัสผ่านนี้ ข้าพเจ้ารับรองว่าข้อมูลทั้งหมดในแบบฟอร์มที่เลือกนั้นเป็นไปตามข้อกำหนดและกฎระเบียบที่บังคับใช้",
    "CDMS706LB002": "รหัสผู้ใช้งาน",
    "CDMS706LB003": "รหัสผ่าน"
});
